import { render } from "./ModalReferral.vue?vue&type=template&id=f88c6da0&scoped=true"
import script from "./ModalReferral.vue?vue&type=script&lang=js"
export * from "./ModalReferral.vue?vue&type=script&lang=js"

import "./ModalReferral.vue?vue&type=style&index=0&id=f88c6da0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88c6da0"]])

export default __exports__